import { Checkbox, FormControlLabel, FormGroup } from "@material-ui/core";
import { useFormikContext } from "formik";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { getTempPrerequisites } from "../../../../selectors/settingSelectors";
import { getCurrentIndividual } from "../../../../selectors/individualSelectors";
import PreAssignmentDescriptionPopover from "./ChecklistTable/PreAssignmentDescriptionPopover";
import { checklistItemComplete } from "./fieldHelpers";

function EditPrerequisitesContent({ candidate }) {
  const { values, setFieldValue } = useFormikContext();
  const allTempPrerequisites = useSelector(getTempPrerequisites);
  const currentIndividual = useSelector(getCurrentIndividual);

  const editablePrerequisites = useMemo(() => {
    if (!allTempPrerequisites) return [];

    const isRelevantParty = (initiatorParty) => {
      if (currentIndividual.employer && initiatorParty === "agency")
        return false;
      if (currentIndividual.recruiter && initiatorParty === "employer")
        return false;
      return true;
    };

    return Object.values(allTempPrerequisites)
      .map((prereq) => {
        if (
          !isRelevantParty(prereq.attributes.initiatorParty) ||
          prereq.attributes.default
        ) {
          return null;
        }

        const existingItem = values.checklistItems.find(
          (item) => item.tempPrerequisiteId === prereq.id
        );
        console.log(values);
        const isCompleted =
          existingItem &&
          checklistItemComplete(existingItem, currentIndividual);

        return {
          tempPrerequisiteId: prereq.id,
          name: prereq.attributes.name,
          description: prereq.attributes.description,
          isChecked: !!existingItem,
          isDisabled: isCompleted,
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [allTempPrerequisites, currentIndividual, values.checklistItems]);

  const handleToggle = (prereq) => {
    if (prereq.isDisabled) return;

    if (prereq.isChecked) {
      setFieldValue(
        "checklistItems",
        values.checklistItems.filter(
          (item) => item.tempPrerequisiteId !== prereq.tempPrerequisiteId
        )
      );
    } else {
      setFieldValue("checklistItems", [
        ...values.checklistItems,
        { tempPrerequisiteId: prereq.tempPrerequisiteId },
      ]);
    }
  };

  return (
    <>
      <p>
        Select the pre-assignment steps you want to apply to this worker below,
        and then click "Save" to continue.
      </p>
      <div
        className="static-input-label"
        style={{
          paddingBottom: 12,
          fontSize: "13px",
          fontWeight: "600",
          textTransform: "uppercase",
        }}
      >
        Pre-Assignment Steps
      </div>
      <FormGroup style={{ marginLeft: 16 }}>
        {editablePrerequisites.map((prereq) => (
          <div
            key={prereq.tempPrerequisiteId}
            style={{ display: "flex", alignItems: "center", marginBottom: 8 }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={prereq.isChecked}
                  disabled={prereq.isDisabled}
                  onChange={() => handleToggle(prereq)}
                  color="primary"
                />
              }
              label={prereq.name}
            />
            <PreAssignmentDescriptionPopover
              name={prereq.name}
              description={prereq.description}
            />
          </div>
        ))}
      </FormGroup>
    </>
  );
}

export default EditPrerequisitesContent;
